/* eslint-disable */
<template>
  <div>
    <div class="container-fluid">
      <div class="row toolbox-fixed">
        <div class="col-md-6 mb-2 mt-2">
          <input class="form-control block btn-more-radius" @keyup.enter="searchUrunCikislari()" v-model="searchFilter"
            type="text" placeholder="IMEI, HDD, Bayii, Müşteri, Notunuza göre arama yapın...">
        </div>
        <div class="col-md-6 mb-2 mt-2">
          <router-link to="/urun-cikislari/gonderi-yap" role="button"
            :disabled="!canInsertUrunCikis"
            class="btn btn-more-radius btn-success float-right">
            Ürün Çıkışı Yap
          </router-link>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-wait for="cikislar-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Ürün Çıkışları Yükleniyor...</p>
              </div>
            </template>
            <table class="table table-bordered table-hover">
              <thead class="thead-light">
                <tr>
                  <th v-if="0==1" class="align-middle" style="width: 35px;" scope="col">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" v-model="selectAll" id="checkAllUcks">
                      <label class="custom-control-label" for="checkAllUcks"></label>
                    </div>
                  </th>
                  <th style="width: 35px;" scope="col">#</th>
                  <th style="width: 7%;" scope="col">ÇIKIŞ</th>
                  <th class="" style="width: 300px;" scope="col">İÇERİK</th>
                  <th style="width: 12%;" scope="col">BAYİİ</th>
                  <th style="width: 12%;" scope="col">İRSALİYE</th>
                  <th style="width: 18%;" scope="col">KAYIT NOTU</th>
                  <th style="width: 12%;" scope="col">KARGO TAKİP</th>
                  <th scope="col">KOMUTLAR</th>
                </tr>
              </thead>
              <tbody class="tbody-margin">
                <template v-for="(urun, index) in urunler">
                  <tr :key="'trow-first-' + urun.OUT_ID" style="border-bottom: 1px solid #E0E0E0;">
                    <td v-if="0==1" class="align-middle" style="width: 35px !important;">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" :value="urun.OUT_ID"
                          v-model="selectedUckList" v-bind:id="'tcheck-'+urun.OUT_ID">
                        <label class="custom-control-label" v-bind:for="'tcheck-'+urun.OUT_ID"></label>
                      </div>
                    </td>
                    <td class="align-middle" style="width: 35px !important;">{{index+1}}</td>
                    <td class="align-middle justify-content-between lh-condensed" style="width: 7%;" scope="row">
                      <p class="mb-1">{{urun.OUT_DATE_FORMATTED}}</p>
                      <small class="text-muted text-truncate">{{urun.PERSONEL_NAME}}</small>
                    </td>
                    <td class="align-middle y-scroll" scope="row">
                      <div class="scroll-wrapper">
                        <div class="scrollable">
                          <button type="button" class="btn btn-sm btn-more-radius mr-1 mt-1 align-middle"
                            :data-toggle="icerik.MALZEME_HAS_SERIAL ? 'modal' : null" data-target="#modalDevicesList" aria-expanded="false"
                            @click="icerik.MALZEME_HAS_SERIAL ? openModalForUckDevicesList(index) : null"
                            :class="{'btn-primary' : icerikIndex == 0, 'btn-success' : icerikIndex == 1, 'btn-warning' : icerikIndex == 2,
                            'btn-danger' : icerikIndex == 3, 'btn-info' : icerikIndex == 4, 'btn-secondary' : icerikIndex == 5, 
                            'btn-outline-danger' : icerikIndex == 6}"
                            v-for="(icerik, icerikIndex) in parseUrunIcerik(urun.OUT_ICERIK)" v-bind:key="'out-icerik-' + icerikIndex">
                            {{icerik.MALZEME_NAME}} <span class="badge badge-pill badge-light align-middle">{{icerik.MALZEME_QUANTITY}}</span>
                          </button>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle justify-content-between lh-condensed" style="width: 12%;">
                      <p class="mb-1 text-truncate font-semi-bold">{{urun.CUSTOMER_TITLE || 'MÜŞTERİ TANIMSIZ'}}</p>
                      <small class="text-muted">{{urun.RETAILER_NAME}}</small>
                    </td>
                    <td class="align-middle justify-content-between lh-condensed" style="width: 12%;">
                      <div v-on:dbclick="openModalForUpdateDelete(index, 1)">
                        <p class="mb-1 text-truncate font-semi-bold">Fatura No : <span class="text-primary">{{urun.OUT_INVOICE_CODE ? urun.OUT_INVOICE_CODE : '-'}}</span></p>
                        <small class="text-muted">İrsaliye No : {{urun.OUT_WAYBILL_CODE ? urun.OUT_WAYBILL_CODE : '-' }}</small>
                      </div>
                    </td>
                    <td class="align-middle" style="width: 13%;">
                      <span v-if="urun.CAMPAIGN_ID > 0" class="float-left badge badge-primary mr-2">{{urun.CAMPAIGN_NAME}}</span>
                      <span class="text-truncate float-left" :data-toggle2="urun.OUT_NOTE != undefined && urun.OUT_NOTE.length > 30 ? 'tooltip' : ''"
                        data-placement="bottom" :title="urun.OUT_NOTE">{{formatNote(urun.OUT_NOTE)}}</span>
                    </td>
                    <td v-if="urun.OUT_HAND_DELIVERY" class="align-middle text-center" style="width: 10%;">
                      <span class="text-muted">ELDEN TESLİM</span>
                    </td>
                    <td v-if="!urun.OUT_HAND_DELIVERY" class="align-middle text-center cargo-td" style="width: 12%;">
                      <div class="justify-content-between">
                        <a v-if="urun.OUT_POST_TRACKING_CODE" target="_blank" role="button" class="btn btn-outline" :href="parsePostTrackingLink(urun.OUT_POST_TRACKING_CODE, urun.OUT_POST_COMPANY)">
                          <img :src="'static/kargo/' + urun.OUT_POST_COMPANY + '.png'" class="mr-2" width="24" height="24" />
                          <span class="mt-2">{{urun.OUT_POST_TRACKING_CODE}}</span>
                        </a>
                        <template v-else>
                        <span class="text-muted cargo-span">Kargo Takip No. Girilmemiş</span>
                        <a role="button" class="btn btn-primary cargo-btn" @click="selectUrunCikis(index)"
                          data-toggle="modal" data-target="#modalPostTrackingCode">
                          <i class="fas fa-archive mr-2"></i>
                          <span class="text-white">Kargo Takip No. Gir</span>
                        </a>
                        </template>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <div class="btn-group mr-1">
                        <button class="btn btn-outline-primary dropdown-toggle"
                          type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Ürün Çıkış İşlemleri
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <h6 class="dropdown-header">İşlemler</h6>
                          <a role="button" class="dropdown-item" data-toggle="modal"
                            @click="bayiiStokAktar(index)" :disabled="canExportDeviceToRetailer">
                            <i class="fas fa-external-link-alt text-secondary"></i>&nbsp;&nbsp;Bayii Stoğuna Aktar</a>
                          <a role="button" class="dropdown-item" data-toggle="modal"
                            @click="musteriHesabinaKaydet(index)" v-if="canAddDeviceToCustomer && urun.OUT_CUSTOMER > 0">
                            <i class="fas fa-bars text-secondary"></i>&nbsp;&nbsp;&nbsp;Müşteri Hesabına Aktar</a>
                          <a role="button" class="dropdown-item" @click="selectUrunCikis(index)"
                            data-toggle="modal" data-target="#modalMultipleWaybill">
                            <i class="far fa-file text-secondary"></i>&nbsp;&nbsp;&nbsp;&nbsp;İrsaliye Numarası Gir</a>
                          <a role="button" class="dropdown-item" @click="selectUrunCikis(index)"
                            data-toggle="modal" data-target="#modalPostTrackingCode">
                            <i class="fas fa-code text-secondary"></i>&nbsp;&nbsp;Kargo Takip Numarası Gir</a>
                          <a role="button" v-if="0==1" class="dropdown-item" @click="openModalForTags(index)"
                            data-toggle="modal" data-target="#modalBarcodesForPrint">
                            <i class="fas fa-barcode"></i>&nbsp;&nbsp;&nbsp;Ürün Barkodlarını Oluştur</a>
                          <a role="button" class="dropdown-item mb-2" @click="openModalForGuyGuy(index)"
                            data-toggle="modal" data-target="#modalCihazDagilimi">
                            <i class="fas fa-table"></i>&nbsp;&nbsp;&nbsp;Cihaz Dağılımını Görüntüle</a>
                          <h6 class="dropdown-header">Diğer</h6>
                          <a role="button" class="dropdown-item text-danger" :disabled="!canDeleteUrunCikis"
                            @click="openModalForUpdateDelete(index, 1)"
                            data-toggle="modal" data-target="#insertUrunCikisModal" aria-expanded="false">
                            <i class="fas fa-trash-alt text-danger"></i>&nbsp;&nbsp;&nbsp;Kaydı Sil</a>
                        </div>
                      </div>
                      <router-link role="button" class="btn btn-info" :disabled="!canUpdateUrunCikis"
                        :to="'/urun-cikislari/gonderi-yap/' + urun.OUT_ID">
                        <i class="far fa-edit text-white"></i>&nbsp;&nbsp;Düzenle</router-link>
                    </td>
                  </tr>
                </template>
                <tr>
                  <td colspan="8" class="text-center py-4" style="width: 100%">
                    <a role="button" class="btn btn-primary text-white"
                      :disabled="loadMoreClicked" @click="getUrunCikislari()">
                      {{ loadMoreClicked ? "Yükleniyor..." : "Daha fazla kayıt yükle" }}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </v-wait>
        </div>
      </div>
    </div>
    <div v-if="canDeleteUrunCikis" class="modal fade bd-example-modal-lg" id="insertUrunCikisModal" tabindex="-1"
      role="dialog" aria-labelledby="insertUrunCikisModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header bg-danger">
            <h5 class="modal-title text-white" id="trackNumberModalLabel">Ürün çıkış kaydını silmek istediğinizden emin misiniz ?</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="uruncikis-inserting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Kayıt siliniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-4 mb-4">
                    <label for="malzeme-kod">Çıkış Tarihi</label>
                    <datepicker id="malzeme-kod" :disabled="modalOpenFor == 1"
                      :bootstrap-styling="true" v-model="urunCikisKaydi.OUT_DATE"
                      :format="dateFormatter"></datepicker>
                  </div>
                  <div class="col-md-8 mb-4">
                    <label for="malzeme-detail">Müşteri</label>
                    <input type="text" class="form-control" disabled v-model="urunCikisKaydi.CUSTOMER_TITLE" >
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-4">
                    <label class="mb-2">Çıkışı yapılan ürünler</label>
                    <button type="button" class="btn btn-sm btn-more-radius mr-1 mt-1 align-middle"
                      :data-toggle="icerik.MALZEME_HAS_SERIAL ? 'modal' : null" data-target="#modalDevicesList" aria-expanded="false"
                      @click="icerik.MALZEME_HAS_SERIAL ? openModalForUckDevicesList(selectedUrunCikisIndex) : null"
                      :class="{'btn-primary' : icerikIndex == 0, 'btn-success' : icerikIndex == 1, 'btn-secondary' : icerikIndex > 1}"
                      v-for="(icerik, icerikIndex) in parseUrunIcerik(urunCikisKaydi.OUT_ICERIK)" v-bind:key="'out-icerik-' + icerikIndex">
                      {{icerik.MALZEME_NAME}} <span class="badge badge-pill badge-light align-middle">{{icerik.MALZEME_QUANTITY}}</span>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="malzeme-supplier">Ürün Çıkış Notu</label>
                    <textarea rows="3" class="form-control" id="malzeme-supplier" disabled v-model="urunCikisKaydi.OUT_NOTE"></textarea>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="deleteUrunCikis()" class="btn btn-danger">Ürün Çıkış Kaydını Sil</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canUpdateUrunCikis" class="modal fade bd-example-modal-lg"  id="modalMultipleWaybill" tabindex="-1"
      role="dialog" aria-labelledby="insertUrunCikisModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">İrsaliye / fatura numarası girişi</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="mutliple-waybill-setting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Kayıtlar güncelleniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="multiple-waybill-code">İrsaliye Numarasını Girin</label>
                    <input type="text" id="multiple-waybill-code"
                      placeholder="İrsaliye No"
                      v-model="multipleWaybill" class="form-control" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="multiple-invoice-code">Fatura Numarasını Girin</label>
                    <input type="text" id="multiple-invoice-code"
                      placeholder="Fatura No"
                      v-model="multipleInvoice" class="form-control" />
                    <small class="form-text text-muted">Girdiğiniz bilgi, seçtiğiniz bütün kayıtlara uygulanacaktır. Eğer seçtiğiniz kayıtlarda daha önce bir irsaliye/fatura bilgisi girişi yaptıysanız bu bilgi kaybolacaktır.</small>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="setMultipleWaybill()" class="btn btn-danger">Seçilen kayıtları güncelle</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="canAssignTrackingNumber" class="modal fade bd-example-modal-lg"  id="modalPostTrackingCode" tabindex="-1"
      role="dialog" aria-labelledby="insertUrunCikisModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Kargo Takip Numarası Girişi</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="tracking-number-code">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Kargo takip numarası giriliyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row mb-3 pb-4">
                  <div class="col-md-12 mb-3">
                    <div class="custom-control custom-checkbox mr-sm-2">
                      <input type="checkbox" id="outgoing-hand-delivery" class="custom-control-input" v-model="handDelivery">
                      <label class="custom-control-label light-text" for="outgoing-hand-delivery">Bu ürün elden teslim edilmiştir.</label>
                      <small id="outgoing-hand-delivery" class="form-text text-muted">Bu seçeneği işaretlediğinizde bu arıza kaydı için kargo takip numarası girişi yapamazsınız. Aynı zamanda bu kayıt kargo takip numarası bekleyen kayıtlar listesinden de çıkarılmış olur.</small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <label for="multiple-waybill-code">Kargo Takip Numarası</label>
                    <div class="input-group">
                      <input type="text" id="multiple-waybill-code" :disabled="handDelivery"
                        placeholder="Kargo takip numarası..."
                        v-model="postTrackingCode" class="form-control form-control-lg" />
                      <div class="input-group-append">
                        <button class="btn btn-outline-primary dropdown-toggle" type="button" 
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <img width="24" height="24" class="mr-2" :src="'static/kargo/' + postCompany + '.png'" />
                            <span>{{postCompany == 0 ? 'MNG Kargo' : 'Aras Kargo'}}</span>
                        </button>
                        <div class="dropdown-menu">
                          <div class="dropdown-item justify-content-between" @click="selectPostComp(0)">
                            <img width="24" height="24" class="mr-2" src="static/kargo/0.png" />
                            <span>MNG Kargo</span>
                          </div>
                          <div class="dropdown-item justify-content-between" @click="selectPostComp(1)">
                            <img width="24" height="24" class="mr-2" src="static/kargo/1.png" />
                            <span>Aras Kargo</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <small class="form-text text-muted mt-2">Girdiğiniz bilgi, ilgili müşteriye sms ve ya mail yoluyla bildirilecektir.</small>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="setPostTrackingCode()" class="btn btn-danger">Kargo Takip Numarasını Gir</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-xl"  id="modalDevicesList" tabindex="-1"
      role="dialog" aria-labelledby="insertUrunCikisModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Çıkışı yapılan cihazlar listesi</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 0; margin: 0;">
            <v-wait for="uck-devices-loading">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Çıkışı yapılan cihazlar listeleniyor...</p>
                </div>
              </template>
              <table class="table table-bordered">
                <thead class="thead-light">
                  <th style="width: 5%;">#</th>
                  <th style="width: 10%;">ÇIKIŞ</th>
                  <th style="width: 20%;">CİHAZ</th>
                  <th style="width: 20%;">HDD</th>
                  <th style="width: 15%;">GSM</th>
                  <th style="width: 30%;">MÜŞTERİ</th>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in selectedUckDevices" v-bind:key="'uck-device-' + index">
                    <td class="align-middle">{{index + 1}}</td>
                    <td class="align-middle">{{item.OUT_DATE}}</td>
                    <td class="align-middle justify-content-between lh-condensed">
                      <div>
                        <p class="my-0 font-weight-bold">{{item.INFO_DEVICEID}}</p>
                        <small class="mt-1 text-muted">{{item.MALZEME_NAME || 'CİHAZ TÜRÜ SEÇİLMEDİ'}}</small>
                      </div>
                    </td>
                    <td class="align-middle justify-content-between lh-condensed">
                      <div v-if="item.INFO_HDDSERIAL">
                        <p class="my-0 font-weight-bold">{{item.INFO_HDDSERIAL}}</p>
                        <small class="mt-1 text-muted">{{item.INFO_HDDBRAND + '-' + item.INFO_HDDCAPACITY}}</small>
                      </div>
                      <span v-else class="font-weight-bold">-</span>
                    </td>
                    <td class="align-middle"><span>{{formatPhoneNumber(item.INFO_GSM) || '-'}}</span></td>
                    <td class="align-middle justify-content-between lh-condensed">
                      <div>
                        <p class="my-0 font-weight-bold">{{item.CUSTOMER_TITLE || 'MÜŞTERİ SEÇİLMEDİ'}}</p>
                        <small class="mt-1 text-muted text-truncate">{{item.RETAILER_NAME}}</small>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-wait>
          </div>
          <div class="modal-footer" id="footer-234">
            <!--<span class="text-muted pull-left">Bu liste hafızadaki veriler ile oluşturuldu.</span>-->
            <button type="button" class="btn btn-secondary btn-more-radius" data-dismiss="modal">Kapat</button>
            <button type="button" class="btn btn-primary btn-more-radius" @click="copyToClipboard(0)">Seri numaraları kopyala</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-xl"  id="modalCihazDagilimi" tabindex="-1"
      role="dialog" aria-labelledby="insertUrunCikisModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Cihazların Kullanım Alanları</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 0; margin: 0;">
            <v-wait for="uck-devices-loading">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Çıkışı yapılan cihazlar listeleniyor...</p>
                </div>
              </template>
              <table class="table table-bordered">
                <thead class="thead-light">
                  <th style="width: 5%;">#</th>
                  <th style="width: 14%;">ÇIKIŞ</th>
                  <th style="width: 17%;">CİHAZ</th>
                  <th style="width: 17%;">GSM</th>
                  <th style="width: 23%;">MÜŞTERİ</th>
                  <th style="width: 18%;">ARAÇ</th>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in selectedUckCihazDagilimi" v-bind:key="'uck-dagilimi-' + index">
                    <td class="align-middle">{{index + 1}}</td>
                    <td class="align-middle">{{selectedUrunCikis.OUT_DATE_FORMATTED}}</td>
                    <td class="align-middle justify-content-between lh-condensed">
                      <div>
                        <p class="my-0 font-weight-bold">{{item.INFO_DEVICEID}}</p>
                        <small class="mt-1 text-muted">{{item.INFO_DEVICELABEL || 'Cihaz modeli tanımsız'}}</small>
                      </div>
                    </td>
                    <td class="align-middle justify-content-between lh-condensed">
                      {{formatPhoneNumber(item.INFO_GSM) || "-"}}
                    </td>
                    <td class="align-middle justify-content-between lh-condensed">
                      <div>
                        <p class="my-0 font-weight-bold">{{item.CUSTOMER_TITLE}}</p>
                        <small class="mt-1 text-muted">Müşteri Kodu : {{item.CUSTOMER_ID}}</small>
                      </div>
                    </td>
                    <td class="align-middle justify-content-between lh-condensed">
                      <p class="my-0 font-weight-bold">{{item.VEHICLE_NAME}}</p>
                      <small class="mt-1 text-muted">{{item.GROUP_NAME || 'Cihaz modeli tanımsız'}}</small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-wait>
          </div>
          <div class="modal-footer" id="footer-235">
            <button type="button" class="btn btn-secondary btn-more-radius" data-dismiss="modal">Kapat</button>
            <button type="button" class="btn btn-primary btn-more-radius" @click="copyToClipboard(1)">Tabloyu Kopyala</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-xl"  id="modalBarcodesForPrint" tabindex="-1"
      role="dialog" aria-labelledby="insertUrunCikisModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="trackNumberModalLabel">Ürün Barkodları</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 0; margin: 0;">
            <v-wait for="barcodes-loading">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Etiketler oluşturuluyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-6 my-3" v-for="(tag, tagIndex) in tags" v-bind:key="'tag-' + tagIndex">
                    <div class="qrcode rounded border clearfix">
                      <img class="border-right" :src="tag.QR_SRC">
                      <div class="qr-content ml-3" :class="{'my-3' : tagIndex < 2, 'mb-3' : tagIndex > 1}">
                        <p class="qr-product-name">{{tag.PRODUCT_NAME}}</p>
                        <p class="qr-data-row float-left mr-4">S.N: </p><p class="qr-data-row float-right font-semi-bold">{{tag.IMEI}}</p>
                        <div class="clearfix"></div>
                        <p class="qr-data-row float-left mr-4">KÜNYE: </p><p class="qr-data-row float-right font-semi-bold">{{tag.FIRMWARE}}</p>
                        <div class="clearfix"></div>
                        <p v-if="tag.HDD_SERIAL" class="qr-data-row float-left mr-4">HDD S.N: </p><p v-if="tag.HDD_SERIAL" class="qr-data-row float-right font-semi-bold">{{tag.HDD_SERIAL}}</p>
                        <div class="clearfix"></div>
                        <p v-if="tag.HDD_CAPACITY != '0'" class="qr-data-row float-left mr-4">KAPASİTE: </p><p v-if="tag.HDD_CAPACITY != '0'" class="qr-data-row float-right font-semi-bold">{{tag.HDD_CAPACITY}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer" id="footer-345">
            <button type="button" class="btn btn-secondary btn-more-radius" data-dismiss="modal">Kapat</button>
            <button type="button" @click="printDocument()" class="btn btn-more-radius btn-danger">Etiketleri Yazdır</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import moment from 'moment'
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import {tr} from 'vuejs-datepicker/dist/locale'
import autocompl from 'vue-bootstrap-typeahead'
import _ from 'lodash'

export default {
  name: 'CikislarPage',
  components: {
    'datepicker': Datepicker,
    'autocomplete': autocompl
  },
  data () {
    return {
      contextId: '',
      tr: "tr",
      searchFilter: '',
      urunler: [],
      urunCikisKaydi: {
        OUT_HDD_BRAND: "Marka",
        OUT_HDD_CAPACITY: "0",
        OUT_RETAILER: "0",
        OUT_DATE: ""
      },
      backupUck: {},
      customerSearchFilter: '',
      foundCustomers: [],
      selectedCustomer: {},
      selectedUrunCikis: {},
      selectedUrunCikisIndex: -1,
      modalOpenFor: 0,
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      },
      selectedUckList: [],
      selectedUckDevices: [],
      selectedUckCihazDagilimi: [],
      multipleWaybill: '',
      multipleInvoice: '',
      postTrackingCode: '',
      postCompany: 0,
      handDelivery: false,
      tags: [],
      loadMoreClicked: false,
      page: 0,
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    canInsertUrunCikis : function() { return this.$store.getters.userCanInsertUrunCikis },
    canUpdateUrunCikis : function() { return this.$store.getters.userCanUpdateUrunCikis },
    canDeleteUrunCikis : function() { return this.$store.getters.userCanDeleteUrunCikis },
    canAddDeviceToCustomer : function() { return this.$store.getters.userCanAddDeviceToCustomer },
    canExportDeviceToRetailer : function() { return this.$store.getters.userCanExportDeviceToRetailer},
    canAssignTrackingNumber: function() { return this.$store.getters.userCanAssignTrackingNumber },
    withContext: function() { return this.contextId != null && this.contextId.length == 32 },
    isMultipleUckSelected: function () { return this.selectedUckList.length > 0 },
    selectAll: {
      get: function () {
        return this.selectedUckList ? this.urunler.length == this.selectedUckList.length : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.urunler.forEach(function (urun) {
            selected.push(urun.OUT_ID);
          });
        }
        this.selectedUckList = selected;
      }
    }
  },
  methods: {
    parseTags() {
      this.$wait.start('barcodes-loading')
      this.tags = []
      for(let i = 0; i < this.selectedUckDevices.length; i++) {
        let tag = {}
        tag.IMEI = this.selectedUckDevices[i].INFO_DEVICEID
        tag.FIRMWARE = 'HX103G1V36R02'
        tag.HDD_SERIAL = this.selectedUckDevices[i].INFO_HDDSERIAL
        tag.HDD_CAPACITY = this.selectedUckDevices[i].INFO_HDDCAPACITY
        tag.PRODUCT_NAME = this.selectedUckDevices[i].INFO_DEVICELABEL + ' NVR'
        this.tags.push(tag)
        tag.QR_SRC = this.parseQrSrc(tag)
        tag.PRODUCT_NAME = 'HX10 3G NVR'
      }
      this.$wait.end('barcodes-loading')
    },
    parseQrSrc(tag) {
      return 'https://chart.googleapis.com/chart?cht=qr&chs=160x160&chl=' + tag.IMEI + ";" + tag.HDD_SERIAL + ";" + tag.HDD_CAPACITY + ";" + tag.FIRMWARE
    },
    async getUckDevices() {
      if(this.selectedUrunCikis.cikislar) {
        this.selectedUckDevices = this.selectedUrunCikis.cikislar
        
      } else {
        this.$wait.start('uck-devices-loading')
        axios.post('/api/uruncikis/uck-devices-list?SessionId=' + this.getSessionId + '&OutId=' + this.selectedUrunCikis.OUT_ID)
        .then(response => {
          this.selectedUckDevices = response.data
          this.urunler[this.selectedUrunCikisIndex].cikislar = response.data
          this.$wait.end('uck-devices-loading')
          this.parseTags()  
        })
        .catch(error => { 
          console.error(error) 
          this.$wait.end('uck-devices-loading')
        })
      }
    },
    async getUckCihazDagilimi() {
      this.$wait.start('uck-devices-loading')
      axios.post('/api/uruncikis/cihaz-dagilimi?SessionId=' + this.getSessionId + '&OutId=' + this.selectedUrunCikis.OUT_ID)
      .then(response => {
        this.selectedUckCihazDagilimi = response.data
        this.$wait.end('uck-devices-loading')
        this.parseTags()  
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('uck-devices-loading')
      })
    },
    searchUrunCikislari() {
      this.page = 0
      this.getUrunCikislari()
    },
    getUrunCikislari() {
      if(this.$route.params.id != null)
        this.contextId = this.$route.params.id

      if(this.page == 0) 
        this.$wait.start('cikislar-loading')
      else
        this.loadMoreClicked = true;

      axios.post('/api/uruncikis/tum-kayitlar-v2?sessionid=' 
        + this.getSessionId + '&searchFilter=' + this.searchFilter + '&contextId=' + this.contextId
        + '&page=' + this.page)
      .then(response => {

        if(this.page == 0)
          this.urunler = response.data
        else
          this.urunler.push(...response.data);

        this.page++
        this.$wait.end('cikislar-loading')
        this.loadMoreClicked = false;
      })
      .catch(error => { 
        console.error(error) 
        this.$wait.end('cikislar-loading')
        this.loadMoreClicked = false;
      })
    },
    insertUrunCikis() {
      this.$wait.start('uruncikis-inserting')
      this.urunCikisKaydi.SessionId = this.getSessionId
      this.urunCikisKaydi.OUT_CUSTOMER = this.selectedCustomer.CUSTOMER_ID

      axios.post("/api/uruncikis/gonderi-yap", this.urunCikisKaydi)
      .then(response => {
        if(response.data.HasError == false)
          this.$toasted.success('Ürün çıkış kaydı ' + (this.selectedUrunCikis ? 'güncellendi' : 'eklendi'), this.toastOptions)      
        else
          this.$toasted.error('Kayıt eklenemedi. Durum mesajı: ' + response.data.ErrorMessage)

        this.$wait.end('uruncikis-inserting')
        $('#insertUrunCikisModal').modal('hide')

        this.getUrunCikislari()
        this.selectedCustomer = {}
        this.foundCustomers = []
        this.customerSearchFilter = ''
        this.multipleWaybill = ''
        this.postTrackingCode = ''
      }).catch(error => console.log(error))
    },
    deleteUrunCikis() {
      this.$wait.start('uruncikis-inserting')

      axios.post("/api/uruncikis/gonderi-sil?outId=" + this.selectedUrunCikis.OUT_ID)
      .then(response => {
        if(response.data.HasError == false)
          this.$toasted.success('Ürün çıkış kaydı silindi', this.toastOptions)
        else
          this.$toasted.error('Kayıt silinemedi. Durum mesajı: ' + response.data.ErrorMessage, this.toastOptions)
        
        this.$wait.end('uruncikis-inserting')
        $('#insertUrunCikisModal').modal('hide')

        this.getUrunCikislari()
        this.selectedCustomer = {}
        this.foundCustomers = []
        this.customerSearchFilter = ''
        this.multipleWaybill = ''
        this.postTrackingCode = ''
      }).catch(error => console.log(error))
    },
    bayiiStokAktar(index) {
      this.selectUrunCikis(index)
      this.$wait.start('uruncikis-inserting')

      axios.post("/api/uruncikis/bayii-stok-aktar?SessionId="+ 
        this.getSessionId + "&ContextId=" + this.selectedUrunCikis.CONTEXT_ID)
      .then(response => {
        if(response.data.HasError == false)
          this.$toasted.success('Cihazlar bayii stoğuna aktarıldı.', this.toastOptions)      
        else
          this.$toasted.error('Cihazlar bayii stoğuna aktarılamadı. Hata: ' + response.data.ErrorMessage, this.toastOptions)

        this.$wait.end('uruncikis-inserting')
        this.$router.push('/urun-cikislari')
      }).catch(error => console.log(error))
    },
    musteriHesabinaKaydet(index) {
      this.selectUrunCikis(index)
      this.$wait.start('uruncikis-inserting')

      axios.post("/api/uruncikis/musteri-hesabina-kaydet?SessionId="
        + this.getSessionId + "&ContextId=" + this.selectedUrunCikis.CONTEXT_ID)
      .then(response => {
        if(response.data.HasError == false)
          this.$toasted.success('Cihazlar müşteri hesabına aktarıldı.', this.toastOptions)      
        else
          this.$toasted.error('Cihazlar müşteri hesabına kaydedilemedi. Hata: ' + response.data.ErrorMessage, this.toastOptions)

        this.$wait.end('uruncikis-inserting')
        this.$router.push('/urun-cikislari')
      }).catch(error => console.log(error))
    },
    dateFormatter(date) {
      return moment(date).format('DD.MM.YYYY')
    },
    formatTitle(title) {
      if(title && title.length > 24)
        return title.substring(0, 21) + "..."
      else return title
    },
    formatNote(title) {
      if(title && title.length > 30)
        return title.substring(0, 26) + "..."
      else return title
    },
    openModalForUpdateDelete(index, openFor) {
      this.modalOpenFor = openFor
      this.selectUrunCikis(index)
      this.urunCikisKaydi = this.selectedUrunCikis
    },
    openModalForInsert() {
      this.modalOpenFor = 0
      this.selectedUrunCikis = {}
      console.log(this.backupUck)
      this.urunCikisKaydi = this.backupUck
    },
    openModalForUckDevicesList(index) {
      this.selectUrunCikis(index);
      this.getUckDevices()
    },
    openModalForTags(index) {
      this.tags = []
      this.selectUrunCikis(index)
      this.getUckDevices()
    },
    openModalForGuyGuy(index) {
      this.tags = []
      this.selectUrunCikis(index)
      this.getUckCihazDagilimi()
    },
    selectUrunCikis(index) {
      this.selectedUrunCikisIndex = index
      this.selectedUrunCikis = this.urunler[index]
      this.customerSearchFilter = this.selectedUrunCikis.CUSTOMER_TITLE
      this.selectedCustomer.CUSTOMER_ID = this.selectedUrunCikis.OUT_CUSTOMER
      this.selectedCustomer.CUSTOMER_TITLE = this.selectedUrunCikis.CUSTOMER_TITLE
      this.multipleWaybill = this.selectedUrunCikis.OUT_WAYBILL_CODE
      this.multipleInvoice = this.selectedUrunCikis.OUT_INVOICE_CODE
      this.postTrackingCode = this.selectedUrunCikis.OUT_POST_TRACKING_CODE
      this.handDelivery = this.selectedUrunCikis.OUT_HAND_DELIVERY
    },
    async getCustomersByText(query) {
      if(!query || query.length < 4)
        return

      let jsonReq = {}
      jsonReq.SessionId = this.getSessionId
      jsonReq.SearchFilter = query
      await axios.post('/api/uruncikis/musteri-ara?sessionid=' + jsonReq.SessionId + "&searchFilter=" + jsonReq.SearchFilter, jsonReq)
      .then(response => this.foundCustomers = response.data)
      console.log(this.foundCustomers)
    },
    setMultipleWaybill() {
      if(this.multipleWaybill == null || this.multipleWaybill == undefined || this.multipleWaybill.length == 0) {
        this.$toasted.info('İrsaliye ve ya fatura numarası girmediniz !', this.toastOptions)
        return;
      }

      this.$wait.start('mutliple-waybill-setting')

      axios.post('/api/uruncikis/toplu-irsaliye-girisi?SessionId=' 
        + this.getSessionId + "&Cikislar=" + this.selectedUrunCikis.OUT_ID + "&WaybillCode=" + this.multipleWaybill + "&InvoiceCode=" + this.multipleInvoice)
      .then(resp => {
        if(resp.data.HasError == false)
          this.$toasted.success('İşlem başarılı', this.toastOptions)
        else
          this.$toasted.error('İşlem yapılamadı. Durum: ' + resp.data.ErrorMessage, this.toastOptions)

        $("#modalMultipleWaybill").modal('hide')
        this.$wait.end('mutliple-waybill-setting')
        this.selectedUckList = [];
        this.getUrunCikislari()
      })
      .catch(error => {
        $("#modalMultipleWaybill").modal('hide')
        this.$toasted.error('İşlem yapılamadı', this.toastOptions)
        this.$wait.end('mutliple-waybill-setting')
      })
    },
    setPostTrackingCode() {
      if(this.handDelivery == false && (this.postTrackingCode != null && this.postTrackingCode.length > 0)) {
        if(this.regexCheck(this.postTrackingCode) == false && this.postCompany == 0) {
          this.$toasted.error('Kargo takip numarası doğru formatta girilmedi.', this.toastOptions)
          return
        }
        else if(this.regexCheckAras(this.postTrackingCode) == false && this.postCompany == 1) {
          this.$toasted.error('Kargo takip numarası doğru formatta girilmedi.', this.toastOptions)
          return
        }
        else {
          let eq = this.urunler.filter(m => m.OUT_POST_TRACKING_CODE == this.postTrackingCode
            && (m.OUT_CUSTOMER != this.selectedUrunCikis.OUT_CUSTOMER || m.OUT_RETAILER != this.selectUrunCikis.OUT_RETAILER))

          console.log(eq);
          if(eq != null && eq.length > 0) {
              this.$toasted.error('Kargo takip numarası farklı bir müşteriye yapılan gönderiye ait.', this.toastOptions)
              return;
          }
        }
      }

      this.$wait.start('tracking-number-code')
      this.postTrackingCode = this.postTrackingCode ? this.postTrackingCode : ''
      
      axios.post('/api/uruncikis/takipno-ekle?SessionId=' 
        + this.getSessionId + "&OutId=" + this.selectedUrunCikis.OUT_ID + 
        "&trackingNumber=" + this.postTrackingCode + "&postCompany=" + this.postCompany + 
        "&handDelivery=" + this.handDelivery)
      .then(resp => {
        if(resp.data.HasError == false)
          this.$toasted.success('Kargo takip numarası ayarlandı.', this.toastOptions)
        else
          this.$toasted.error('İşlem yapılamadı. Durum: ' + resp.data.ErrorMessage, this.toastOptions)

        $("#modalPostTrackingCode").modal('hide')
        this.$wait.end('tracking-number-code')
        this.urunler[this.selectedUrunCikisIndex].OUT_POST_TRACKING_CODE = this.postTrackingCode
        this.urunler[this.selectedUrunCikisIndex].OUT_POST_COMPANY = this.postCompany
        this.postTrackingCode = ''
        this.postCompany = 0
        this.multipleWaybill = ''
        this.handDelivery = false
      })
      .catch(error => {
        $("#modalPostTrackingCode").modal('hide')
        this.$toasted.error('İşlem yapılamadı', this.toastOptions)
        this.$wait.end('tracking-number-code')
      })
    },
    parseUrunIcerik(val) {
      if(val == null) return null;
      if(val.length <= 0) return null;

      let toReturn = []
      let arr = []
      arr = val.split(',');
      for(let k = 0; k < arr.length; k++) {
        let ob = arr[k].split('-')
        toReturn.push({ 'MALZEME_ID': ob[0].trim(), 'MALZEME_NAME': ob[1].trim(), 'MALZEME_QUANTITY': ob[2].trim(), 'MALZEME_HAS_SERIAL': ob[3].trim() == "1" })
      }

      return toReturn;
    },
    parsePopoverContent(index) {
      return 'test content'
    },
    parsePostTrackingLink(ptCode, ptComp) {
      if(ptComp == 1)
        return ptCode ? "https://www.araskargo.com.tr/tr/cargo_tracking_detail.aspx?r=3840731query%3d1&querydetail=2&ref_no=&seri_no=&irs_no=&kargo_takip_no="+ ptCode +"&atf_no=&customer_code=&integration_code=" : null
      else
        return ptCode ? "https://service.mngkargo.com.tr/iactive/popup/KargoTakip/link12.asp?k="+ptCode+"&y=2019" : null
    },
    regexCheck(postCode) {
      const regex = /^([A-Z]{2})([0-9]{5,})$/gm;
      let m = regex.exec(postCode);
      
      if(m == null || m.length == 0)
        return false
      else
        return true
    },
    regexCheckAras(postCode) {
      const regexAras = /^([0-9]{11,})$/gm;
      let m = regexAras.exec(postCode);
      
      if(m == null || m.length == 0)
        return false
      else
        return true
    },
    copyToClipboard (mode) {
      let toCopy = ''
      let rowsOf = 0

      if(mode == 0) {
        rowsOf = this.selectedUckDevices.length;
        for(let i = 0; i < this.selectedUckDevices.length; i++) {
          toCopy += this.selectedUckDevices[i].INFO_DEVICEID + '\t'
          toCopy += this.selectedUckDevices[i].INFO_GSM + '\t'
          console.log(this.selectedUckDevices[i].INFO_HDDBRAND)
          if(this.selectedUckDevices[i].INFO_HDDBRAND.indexOf('Seagate') > -1 || 
            this.selectedUckDevices[i].INFO_HDDBRAND.indexOf('Western') > -1) {
            toCopy += this.selectedUckDevices[i].INFO_HDDBRAND + '\t'
            toCopy += this.selectedUckDevices[i].INFO_HDDSERIAL + '\t'
            toCopy += this.selectedUckDevices[i].INFO_HDDCAPACITY
          }
          toCopy += '\r\n'
        }
      } else {
        rowsOf = this.selectedUckCihazDagilimi.length;
        for(let i2 = 0; i2 < this.selectedUckCihazDagilimi.length; i2++) {
          toCopy += this.selectedUrunCikis.OUT_DATE_FORMATTED + '\t'
          toCopy += this.selectedUckCihazDagilimi[i2].INFO_DEVICEID + '\t'
          toCopy += this.selectedUckCihazDagilimi[i2].INFO_GSM + '\t'
          toCopy += this.selectedUckCihazDagilimi[i2].CUSTOMER_ID + '\t'
          toCopy += this.selectedUckCihazDagilimi[i2].CUSTOMER_TITLE + '\t'
          toCopy += this.selectedUckCihazDagilimi[i2].VEHICLE_ID + '\t'
          toCopy += this.selectedUckCihazDagilimi[i2].VEHICLE_NAME + '\t'
          toCopy += this.selectedUckCihazDagilimi[i2].GROUP_NAME + '\r\n'
        }
      }

      var footer = document.getElementById(mode == 0 ? 'footer-234' : 'footer-235')
      var el = document.createElement('textarea');
      el.value = toCopy
      el.style.width = '1px'
      el.style.height = '1px'
      el.style.opacity = '0'
      footer.appendChild(el);
      el.select();

      try {
        var success = document.execCommand("copy")
        if(success)
          this.$toasted.info(mode == 0 ? 'Seri numaraları kopyalandı' : 'Tablo kopyalandı', { theme: 'bubble', position: 'top-center', duration: 2500 })
      } catch(err) {
        alert(err)
      }

      footer.removeChild(el);
      el = null
      footer = null
      toCopy = ''
    },
    selectPostComp(pc) {
      this.postCompany = pc
    },
    formatPhoneNumber(phoneNumberString) {
      var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
      var match = cleaned.match(/^(\d{3})(\d{3})(\d{2})(\d{2})$/)
      if (match) {
        return '0 ' + match[1] + ' ' + match[2] + ' ' + match[3] + ' ' + match[4]
      }
      return null
    }
  },
  watch: {
    customerSearchFilter: _.debounce(function(val) { this.getCustomersByText(val) }, 500),
    '$route.params.id': function() {  this.getUrunCikislari(); }
  },
  beforeMount() {
    moment.locale('tr')
  },
  mounted() {
    this.backupUck = this.urunCikisKaydi
    this.getUrunCikislari()
  },
}
</script>

<style scoped>

  .cargo-td .cargo-btn {
    display: none;
  }

  .cargo-td:hover .cargo-span {
    display: none;
  }

  .cargo-td:hover .cargo-btn {
    display: inline-block;
  }

  .qrcode {

  }

  .qrcode img {
    float:left;
  }

  .qrcode .qr-content {
    float: left;
  }

  .qrcode .qr-content .qr-data-row {
    font-size: .75rem;
    margin: 0;
    margin-bottom: 3px;
  }

  .qrcode .qr-content .qr-product-name {
    font-size: 1.4rem;
    font-weight: 500;
    margin-bottom: 0px;
  }

  .font-semi-bold {
    font-weight: 600;
  }

  table {
    table-layout: fixed;
  }

  .y-scroll {
    width: 300px;
    height: 60px;
    padding: 0;
    background-color: transparent;
    position: relative;
  }

  div.scroll-wrapper {
    width: 300px;
    max-height: 60px;
    overflow: hidden;
    padding: 0;
    z-index: -1;
  }

  div.scrollable {
    max-width: 100%;
    width: 100%;

    min-height: 100%;
    height: auto;

    padding: 12px 5px 12px 5px;
    z-index: -1;
    border: 1px solid transparent;
  }

  div.scrollable .btn {
    margin: 0 5px 15px 0;
    z-index: -111;
  }

  .y-scroll:hover {
    z-index: 9;
  }

  .y-scroll:hover div.scroll-wrapper {
    overflow: visible;
  }

  .y-scroll:hover div.scroll-wrapper div.scrollable {
    background-color: #F5F6FF;
    border: 1px solid #909090;
    z-index: 10;
    box-shadow: 0 10px 20px rgba(0,0,0,.25);
  }

  /*
  .y-scroll:hover div.scroll-wrapper div.scrollable::after {
    content: "\f139"; 
    font-family: "Font Awesome 5 Free" !important;
    position: absolute;
    top: 22px;
    right: 10px;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    background-color: darkkhaki;
  }
  */

  .y-scroll:hover div.scroll-wrapper div.scrollable .btn {
    margin: 0 5px 5px 0;
  }

  /*div.scrollable {
    width: 360px;
    max-width: 100%;
    height: auto;
    min-height: 35px;
    z-index: 4;
    background-color: red;
  }*/

  /*.y-scroll {
    display: block;
    width: 360px !important;
    max-width: 360px;
    min-height: 60px;
    height: auto;
    overflow: hidden !important;
    white-space: nowrap;
    padding-left: 5px !important;
    padding-right: 5px !important;
    border: none;
  }

  .y-scroll:hover { 
    overflow-y: auto !important;
  }*/

  html, body {
    overflow-x: hidden;
  }

  .thead-fixed {
    table-layout: fixed;
    overflow: hidden;
    width: 100%;
    position: fixed;
    z-index: 98;
    top: 113px;
  }

  .thead-fixed tx {
    padding-left: 10%;
    padding-right: 10%;
  }

  .toolbox-fixedx {
    overflow: hidden;
    width: 100%;
    position: fixed;
    z-index: 99;
    top: 61px;
    background-color: #F0F0F0;
  }

  table {
    table-layout: fixed;
    margin-top: 0px;
  }

  input[type="text"].loading, input[type="search"].loading {
    background-image: url("~/static/loading.svg");
    background-size: 32px 32px;
    background-position:right center;
    background-repeat: no-repeat;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .header-fixed {
    position: absolute;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn.dropdown-toggle {
    font-size: .875rem
  }

  td .btn {
    font-size: .75rem;
  }

  td a.btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .lh-condensed { line-height: 1.25; } 

  p { display: block;}

  .text-truncate {
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .auto-width-div {
    display: inline-block;
    height: 35px;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    min-width: 100% !important;
    max-width: 500%;
    width: 250px;
  }

</style>


// WEBPACK FOOTER //
// src/components/CikislarV2Page.vue